import { render, staticRenderFns } from "./DoudianProductEditorDialog.vue?vue&type=template&id=1d5c91ca&scoped=true"
import script from "./DoudianProductEditorDialog.vue?vue&type=script&lang=js"
export * from "./DoudianProductEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./DoudianProductEditorDialog.vue?vue&type=style&index=0&id=1d5c91ca&prod&scoped=true&lang=css"
import style1 from "./DoudianProductEditorDialog.vue?vue&type=style&index=1&id=1d5c91ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c91ca",
  null
  
)

export default component.exports